import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HomeService from "../Services/Home";
import DefaultBook from "../Images/defaultBook.png";
import { Breadcrumbs } from "./E-BooksComponent";
import Loader from "./Loader";
import "../Styles/MagazineLanding.css";

const ArrowRightIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const MagazineLandingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [magazines, setMagazines] = useState<any[] | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    // debugger;
    HomeService.getmagzinepost(0, 10)
      .then((res) => {
        if (res?.status && res?.result?.items) {
          setMagazines(res.result.items);
          // console.log(res.result.items)
        }
      })
      .catch((err) => {
        console.error("Error fetching magazines:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleCardClick = (productId: number, lang?: string) => {
    const normalizedLang = lang?.trim() ?? "";
    switch (productId) {
      case 5:
        navigate(`/magazines/kalyan`, { state: { magazineLangauge: normalizedLang } });
        break;
      case 6:
        navigate(`/magazines/kalyanakalpataru`, { state: { magazineLangauge: normalizedLang } });
        break;
      case 7:
        navigate(`/magazines/geetgovind`, { state: { magazineLangauge: normalizedLang } });
        break;
      case 8:
        navigate(`/magazines/vivekvani`, { state: { magazineLangauge: normalizedLang } });
        break;
      default:
        navigate(`/books`);
        break;
    }
  };

      const style:any=()=>{
        return(
            <h1 style={{fontWeight:700,fontSize:"36px"}}>{t("magazine_tr")}</h1>
        )
    }
    

  return (
    <>

<div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h1 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("magazine_tr")}
                  </h1>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("magazine_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h2
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                  }}
                >
                  {t("E_magazines_title_tr")}
                </h2>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "center",
                  }}
                >
                  {t("E_magazines_description_tr")}
                </p>
              </div>
            </div>
      </div>
  </div>

      <div className="magazine-landing-section">
        <div className="containers">
          {loading ? (
            <div style={{ minHeight: "300px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Loader loading={loading} />
            </div>
          ) : (
            <>
              <div className="magazine-header">
                {/* <span className="magazine-subtitle">— {t("Explore_Categories_tr", "EXPLORE CATEGORIES")} —</span>
                <h1 className="magazine-title">
                  {magazines ? magazines.length : 6} {t("Categories_Endless_Stories_tr", "Categories. Endless Stories.")}
                </h1>
                <p className="magazine-desc">
                  {t(
                    "Discover_Magazines_Desc_tr",
                    "Discover magazines that inspire, inform and entertain across every aspect of life."
                  )}
                </p> */}
              </div>

              {magazines && magazines.length > 0 ? (
                <div className="magazine-grid">
                  {magazines.map((item, index) => {
                    // Alternating Gradient Classes: gradient-a (even), gradient-b (odd)
                    const gradientClass = index % 2 === 0 ? "gradient-a" : "gradient-b";

                    // Localize language label if possible
                    const langLabel = item.magazineLangauge
                      ? item.magazineLangauge.charAt(0).toUpperCase() + item.magazineLangauge.slice(1)
                      : "Hindi";

                    // Prefer the API-provided magazineTotal; fall back to common alternatives
                    const totalIssues = Number(
                      item.magazineTotal ?? item.total ?? item.totalIssues ?? item.magazineTotalCount ?? 0
                    );

                    return (
                      <div
                        key={item.id || index}
                        className={`magazine-card ${gradientClass}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleCardClick(item.productId, item.magazineLangauge)}
                      >
                        <div className="magazine-card-left">
                          <img
                            className="magazine-book-cover"
                            src={item.coverPagePath || item.coverPageThumbPath || DefaultBook}
                            onError={(e) => {
                              e.currentTarget.src = DefaultBook;
                            }}
                            alt={item.name}
                            title={item.name}
                          />
                        </div>

                        <div className="magazine-card-right">
                          <div>
                            <h3 className="magazine-card-title">
                              {item.name || t("magazine_tr")}
                            </h3>

                            {item.description && (
                              <div
                                className="magazine-card-description"
                                dangerouslySetInnerHTML={{ __html: item.description }}
                              />
                            )}

                            <div className="magazine-card-properties">
                              <span className="magazine-prop">
                                <strong>{t("Language_tr", "Language")}:</strong>
                                &nbsp;{langLabel}
                              </span>
                              <span className="magazine-prop">
                                <strong>{t("Issues_tr", "Issues")}:</strong>
                                &nbsp;{totalIssues}
                              </span>
                            </div>

                            <div className="magazine-card-meta magazine-card-latest-issue">
                              <span>{t("LatestIssue_tr", "Latest issue")}:</span>
                              <span className="magazine-card-latest-value">
                                {item.latest_Issue?.formattedIssue ?? "—"}
                              </span>
                            </div>
                          </div>

                          <button
                            className="magazine-collection-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCardClick(item.productId, item.magazineLangauge);
                            }}
                          >
                            {t("magazine_view_all_tr")} <ArrowRightIcon />
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{ textAlign: "center", padding: "40px", fontSize: "20px", color: "#3f220d" }}>
                  {t("result_not_found_tr")}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MagazineLandingPage;
